const defaultOptions = { precision: 2, sign: '' }

/**
 * Formats numerical to percentage
 *
 * @param {(string|number)} value - Numeric value
 *
 * @example
 * ```
 * formatPrecision("2.12", { sign: '%', precision: 2 }) // Prints 2.12%
 */
export const formatPrecision = (value, { precision, sign } = defaultOptions) => {
  return value ? `${+parseFloat(value).toFixed(precision ?? defaultOptions.precision)}${sign ?? defaultOptions.sign}` : undefined
}
